/**
 * @generated SignedSource<<4964f1904e11d04e6bb443ae38ea3d01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateUserInput = {
  clientMutationId?: string | null;
  company?: string | null;
  email?: string | null;
  isMacbeeServer?: boolean | null;
  isCrossDomainQuery?: boolean | null;
  isCrossDomainFragment?: boolean | null;
  enableBackendUrlMapping?: boolean | null;
  isSecure?: boolean | null;
  itpUrls?: string | null;
  name?: string | null;
  tel?: string | null;
  userTag?: string | null;
  jsTagManagementEnabled?: boolean | null;
};
export type AccountSwitch_Mutation$variables = {
  input: UpdateUserInput;
};
export type AccountSwitch_MutationVariables = AccountSwitch_Mutation$variables;
export type AccountSwitch_Mutation$data = {
  readonly updateUser: {
    readonly user: {
      readonly name: string | null;
      readonly isCrossDomainQuery: boolean;
      readonly isCrossDomainFragment: boolean;
      readonly jsTagManagementEnabled: boolean;
      readonly userTag: string | null;
      readonly enableBackendUrlMapping: boolean;
    };
  } | null;
};
export type AccountSwitch_MutationResponse = AccountSwitch_Mutation$data;
export type AccountSwitch_Mutation = {
  variables: AccountSwitch_MutationVariables;
  response: AccountSwitch_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCrossDomainQuery",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCrossDomainFragment",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jsTagManagementEnabled",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userTag",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enableBackendUrlMapping",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountSwitch_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountSwitch_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8bf0c46da871b22539e86a952469c137",
    "id": null,
    "metadata": {},
    "name": "AccountSwitch_Mutation",
    "operationKind": "mutation",
    "text": "mutation AccountSwitch_Mutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      name\n      isCrossDomainQuery\n      isCrossDomainFragment\n      jsTagManagementEnabled\n      userTag\n      enableBackendUrlMapping\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "687323b02f1a94cf2bc7766387e3c505";

export default node;
